import MaoDeObraView from "../../components/gestaoOrcamentaria/MaoDeObraView";
import { DEPARTAMENTOS_CUSTO_MAO_DE_OBRA } from "../../constants/departamentosOrcamento";

export default function MaoDeObra() {
  return <MaoDeObraView tituloModulo="Custo Mão de Obra" departamentos={DEPARTAMENTOS_CUSTO_MAO_DE_OBRA} />;
}
